import {useEffect, useRef} from 'react';
import {useSelector} from 'react-redux';
import Selector from '../../../../selectors/layers/main/games';
import Navigation from './navigation';
import Game from './game';
import Map from './map.json';
import MapMobile from './map_mobile.json';
import {parseMap} from '../../../../utils/games';
import Slider from 'react-slick';
import Language from '../../../../language';
import {isMobile} from '../../../../utils/viewport';
import ImageUtil from '../../../../utils/image';

export default () => {
    const {games_tab, favorites} = useSelector(Selector),
          {vertical, horizontal, count} = parseMap(isMobile() ? MapMobile.slice() : Map.slice(), games_tab, favorites);

    const slider = useRef();

    useEffect(() => {
        if(slider.current)
            slider.current.slickGoTo(0, true);
    }, [vertical, horizontal]);

    useEffect(() => {
        const container = document.querySelector('.game-container');

        if(container)
            container.scrollLeft = 0;
    }, [games_tab]);

    return (
        <>
            <Navigation />
            <div className="game-container animate__animated animate__fadeIn">
                {games_tab === "favorites" && (vertical.length === 0 && horizontal.length === 0) ? (
                        <div className="favorites-plug animate__animated animate__fadeIn">
                            <div className="finger animate__animated animate__infinite animate__pulse"></div>

                            <div className="game">
                                <div className="border"></div>
                                <div className="favorite">
                                    <div className={`status`}></div>
                                    <div className="fav-border"></div>
                                </div>
                                <div className="image">
                                    <ImageUtil
                                        path={`/games/gingerland.png`}
                                        alt={'The Gingerbread Land'} />
                                </div>
                            </div>

                            <div className="plug-text" dangerouslySetInnerHTML={{__html: Language('layers.main.no_favorites')}}></div>
                        </div>
                ) : (
                    <>
                        {
                            isMobile()
                            ? (
                                <div className="games-scroll" style={{
                                    width: `calc(218px * ${count})`
                                }}>
                                    {vertical.map((game, key) => {
                                        return (
                                            <div className="games vertical" key={key}>
                                                <Game props={game} key={key} />
                                            </div>
                                        )
                                    })} 

                                    {horizontal.map((games, key) => {
                                        return (
                                            <div className="games" key={key}>
                                                {games.map((props, g_key) => <Game props={props} key={g_key} />)}
                                            </div>
                                        )
                                    })}
                                </div>
                            )
                            : (
                                <Slider
                                    dots={false}
                                    infinite={false}
                                    slidesToShow={5}
                                    slidesToScroll={5}
                                    arrows={false}
                                    ref={slider}>
                                    {vertical.map((game, key) => {
                                        return (
                                            <div key={key}>
                                                <div className="games vertical">
                                                    <Game props={game} key={key} />
                                                </div>
                                            </div>
                                        )
                                    })}

                                    {horizontal.map((games, key) => {
                                        return (
                                            <div key={key}>
                                                <div className="games">
                                                    {games.map((props, g_key) => <Game props={props} key={g_key} />)}
                                                </div>
                                            </div>
                                        )
                                    })}
                                </Slider>
                            )
                        }
                    </>
                )}
            </div>
        </>
    )
}